/***********************/
/* Angular + external */
import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  OnChanges,
  ChangeDetectorRef,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
/***********************/
/* BFX */

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { d3oe } from "../../shared/d3-oe/d3-order-entry";
import { StrategyLayoutData } from "../../shared/d3-oe/strategy-layout/StrategyLayoutData";
import { PerfectScrollbarComponent } from "@bfx/ngx-perfect-scrollbar";
import { OECoordinatorService } from "../services/oe-coordinator.service";
import { OEStrategyLayoutService } from "../services/oe-strategy-layout.service";
import { OENCommand } from "../data/enums/oe-command.enum";
import { OECommandEventModel } from "../data/models/oe-command-event.model";
import { OEApiService } from "../services/oe-api.service";
import { OEStrategyRenderService } from "../services/basic/oe-strategy-render.service";
import { runDetached } from "../../../shared/helper-services/run-detached";

// services

@Component({
  selector: "bfx-panel-strategy",
  templateUrl: "./html/bfx-panel-strategy.html",
  standalone: false,
})
export class OEStrategyPanelComponent implements OnDestroy, OnInit, OnChanges {
  @Input() rootRefId: string;
  @Input() refId: string;

  //@Input('height') input_height: number;

  @ViewChild("strategyLayoutPS", { static: true })
  private strategyLayoutPS: PerfectScrollbarComponent;
  @ViewChild("strategyLayoutTarget", { static: true })
  private strategyLayoutTarget: ElementRef;
  /***************************************/
  /* DATA */
  public config: any = {
    debug: true,
  };

  public data: any = {
    strategyLayoutData: null,
  };

  public control: any = {
    strategyLayout: null,
    scrollbarConfig: {
      suppressScrollX: false, // false is default
      suppressScrollY: false, // false is default
    },
  };

  public style: any = {
    scroll: {
      height: 500,
      maxHeight: 2000,
      minHeight: 400,
      width: 500,
      maxWidth: 500,
      minWidth: 500,
    },
    layoutTarget: {
      height: 480,
      maxHeight: 2000,
      minHeight: 577,
      width: 522,
      maxWidth: 522,
      minWidth: 500,
    },
  };

  //private configurationSubscription: Subscription;
  private coordinatorSubscription: Subscription;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private coordinator: OECoordinatorService,
    private api: OEApiService,
    private render: OEStrategyRenderService,
    private strategyLayout: OEStrategyLayoutService,
    public cd: ChangeDetectorRef,
  ) {
    this.initialize();
  }

  ngOnInit() {}

  ngOnChanges() {
    /* this.style.scroll.height = this.input_height - 10;
		this.style.layoutTarget.minHeight = this.input_height -20;
		this.style.layoutTarget.height = this.input_height - 15;
		//logger.out.info("DEV-TEST ngChanges panel size = " + ( this.input_height) + " px");
		setTimeout(()=>{this.strategyLayoutPS.directiveRef.update();},100); */
  }

  ngOnDestroy() {
    //	this.configurationSubscription.unsubscribe();
    this.coordinatorSubscription.unsubscribe();
  }

  /**********************************************************************/
  /* INITIALIZATION */

  protected initialize(): void {
    this.subscribeToCoordinator();
  }

  private subscribeToCoordinator(): void {
    this.coordinatorSubscription = this.coordinator.strategyPanelCmd$
      .pipe(runDetached(this))
      .subscribe(($event: OECommandEventModel) => {
        if (
          $event.ref === this.refId ||
          $event.ref === this.rootRefId ||
          this.api.isTargetRefIdPartOfActiveStrategySet(this.refId, $event.ref)
        ) {
          switch ($event.cmd) {
            case OENCommand.PANEL_SHOW_STRATEGY:
              this.loadStrategyLayout($event.data);
              break;
            case OENCommand.PANEL_UPDATE_STRATEGY:
              this.updateStrategyNodeLabel($event.ref);
              break;
            case OENCommand.RESET_ALL:
              try {
                // FIXME reset svg manually for now
                let el = this.strategyLayoutTarget.nativeElement;
                while (el.firstChild) {
                  el.firstChild.remove();
                }
              } catch (e) {
                // TODO
              }
              break;
            case OENCommand.PANEL_RESET_STRATEGY:
              if (this.control.strategyLayout != null) {
                this.control.strategyLayout.reset();
              } else {
                logger.out.warn("WARNING: Trying to reset empty/null strategy layout!");
              }
              break;
            case OENCommand.GAMMA_ENABLE_CUST_BUTTON:
            case OENCommand.GAMMA_DISABLE_CUST_BUTTON:
            case OENCommand.GAMMA_UPDATED_CUST_LEG:
            case OENCommand.GAMMA_NEW_LEG_RESP:
            case OENCommand.GAMMA_CUST_CCYPAIR_UPDATE:
            case OENCommand.SAVE_GAMMA_TO_MODEL:
            case OENCommand.GAMMA_DUPLICATE_LOAD:
            case OENCommand.GAMMA_CUSTOM_RATE_CHANGE:
            case OENCommand.UPDATE_GAMMA_ELIGIBLE:
            case OENCommand.UPDATE_GAMMA_INELIGIBLE:
            case OENCommand.GAMMA_CUSTOMISE:
            case OENCommand.GAMMA_RESTORE:
            case OENCommand.GAMMA_TOP_LEG:
            case OENCommand.SAVE_GAMMA_TO_MODEL:
            case OENCommand.UNBULK:
            case OENCommand.BULKED:
            case OENCommand.BULKING: {
              break;
            }
            default:
              logger.out.error(
                "ERROR: _strategyPanel.subscribeToCoordinator(): Command not implemented! command=%s",
                OENCommand[$event.cmd],
              );
              break;
          }
        }
      });
  }

  loadStrategyLayout(data: StrategyLayoutData): void {
    setTimeout(() => {
      let target = this.strategyLayoutTarget.nativeElement;
      let panzoom = null;
      let strategyLayout = null;

      if (data == Object(data)) {
        this.control.strategyLayout = strategyLayout = d3oe.layout //d3
          .entryStrategy(null, this.render)
          .render(data, target, this.refId.toString());

        //this.strategyLayoutPS.update();
        this.strategyLayoutPS.directiveRef.update();
      }
    }, 4);
  }

  public updateStrategyNodeLabel(refId: string): void {
    // FIXME
    setTimeout(() => {
      try {
        let label = this.strategyLayout.getStrategyNodeLabel(refId);

        let strategyDataUpdateEvent = new CustomEvent("strategyDataUpdated", {
          detail: { id: refId, label: label },
        });

        if (
          this.strategyLayoutTarget == Object(this.strategyLayoutTarget) &&
          this.strategyLayoutTarget.nativeElement == Object(this.strategyLayoutTarget.nativeElement)
        ) {
          this.strategyLayoutTarget.nativeElement.dispatchEvent(strategyDataUpdateEvent);
        }
      } catch (e) {
        logger.out.info(`failed to strategyDataUpdated ${refId}`);
      }
    }, 100);
  }

  public selectStrategy($event) {
    if (this.render.validateOrderDataAndNotify(this.refId)) {
      this.api.actionLoadStrategy($event.detail.id);
    }
  }

  public removeStrategy($event) {
    //logger.out.info(`requested removal of strategy with refId ${$event.detail.id}`);
    this.api.actionRemoveStrategy($event.detail.id);
  }

  public resizeStrategy(height: number) {
    this.style.scroll.height = height;
    this.style.layoutTarget.minHeight = height;
    this.style.layoutTarget.height = height;

    setTimeout(() => {
      this.strategyLayoutPS.directiveRef.update();
    }, 0);
  }
}
